export const idlFactory = ({ IDL }) => {
  const Status = IDL.Variant({
    'Passed' : IDL.Null,
    'Refused' : IDL.Null,
    'Pending' : IDL.Null,
  });
  const Info = IDL.Record({
    'url' : IDL.Text,
    'status' : Status,
    'withdrew' : IDL.Bool,
    'discord_account' : IDL.Text,
    'team_number' : IDL.Nat16,
    'acccount' : IDL.Principal,
  });
  const StatsData = IDL.Record({
    'reward' : IDL.Nat,
    'token_holder' : IDL.Principal,
    'closed' : IDL.Bool,
    'token' : IDL.Principal,
    'admin' : IDL.Principal,
    'owner' : IDL.Principal,
  });
  const Result = IDL.Variant({ 'Ok' : StatsData, 'Err' : IDL.Text });
  const Result_1 = IDL.Variant({ 'Ok' : IDL.Null, 'Err' : IDL.Text });
  const Result_2 = IDL.Variant({ 'Ok' : IDL.Nat, 'Err' : IDL.Text });
  return IDL.Service({
    'getAll' : IDL.Func([IDL.Nat64, IDL.Nat64], [IDL.Vec(Info)], ['query']),
    'getStats' : IDL.Func([], [Result], ['query']),
    'pass' : IDL.Func([IDL.Vec(IDL.Principal)], [Result_1], []),
    'refuse' : IDL.Func([IDL.Vec(IDL.Principal)], [Result_1], []),
    'remove' : IDL.Func([IDL.Principal], [Result_1], []),
    'setAdmin' : IDL.Func([IDL.Principal], [Result_1], []),
    'setClosed' : IDL.Func([IDL.Bool], [Result_1], []),
    'setReward' : IDL.Func([IDL.Nat], [Result_1], []),
    'setTokenHolder' : IDL.Func([IDL.Principal], [Result_1], []),
    'submit' : IDL.Func([IDL.Text, IDL.Text, IDL.Nat16], [Result_1], []),
    'withdraw' : IDL.Func([], [Result_2], []),
  });
};
export const init = ({ IDL }) => { return [IDL.Principal, IDL.Nat]; };
